import {
  normalizeDateFromApi,
  normalizeDateForApi,
} from 'helpers/datetimeHelpers';

const normalizeDateFromApiValue = (value: any): Date | null => {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) return value;

  // API contract for autosave dates is timestamp.
  if (
    typeof value === 'number' ||
    (typeof value === 'string' && /^\d+$/.test(value))
  ) {
    return normalizeDateFromApi(Number(value));
  }

  return null;
};

const normalizeDateForApiValue = (value: any): number | null => {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) return normalizeDateForApi(value);
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && /^\d+$/.test(value)) return Number(value);

  return null;
};

export function normalizeApiResponse(
  data: Record<string, any> | null,
): Record<string, any> | null {
  if (!data) return null;
  const normalized = { ...data }; // Create a copy

  if (Object.prototype.hasOwnProperty.call(normalized, 'startDate')) {
    normalized.startDate = normalizeDateFromApiValue(normalized.startDate);
  }
  if (Object.prototype.hasOwnProperty.call(normalized, 'endDate')) {
    normalized.endDate = normalizeDateFromApiValue(normalized.endDate);
  }

  return normalized;
}

export function normalizeApiRequest(
  data: Record<string, any> | null,
): Record<string, any> | null {
  if (!data) return null;
  const normalized = { ...data }; // Create a copy

  if (Object.prototype.hasOwnProperty.call(normalized, 'startDate')) {
    normalized.startDate = normalizeDateForApiValue(normalized.startDate);
  }
  if (Object.prototype.hasOwnProperty.call(normalized, 'endDate')) {
    normalized.endDate = normalizeDateForApiValue(normalized.endDate);
  }

  return normalized;
}
